/* src/app/components/lead-details/lead-detail-signature/lead-detail-signature.component.css */
.signature--container {
  display: flex;
  flex-direction: column;
  align-self: center;
  max-width: 500px;
  margin-bottom: 1rem;
}
/*# sourceMappingURL=lead-detail-signature.component-QNC5GZUY.css.map */
